import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PageNotFound from '@js/components/errors/404.vue';
import FeesList from '@js/components/my/fees/FeesList.vue';
import MyAccount from '@js/components/my/account/MyAccount.vue';
import Dashboard from '@js/components/my/Dashboard.vue';
import ForgotPassword from '@js/components/ForgotPassword.vue';
import PasswordReset from '@js/components/PasswordReset.vue';
import PaymentsList from '@js/components/my/payments/PaymentsList.vue';
import CleanHomesFeesList from '@js/components/my/fees/CleanHomesFeesList.vue';
import RegistrationFeeCheckout from '@js/components/public/RegistrationFeeCheckout.vue';
import PaymentSummaries from '@js/components/my/payments/PaymentSummaries.vue';
import JobOffer from '@js/components/public/JobOffer.vue';
import VerificationSuccess from '@js/components/my/account/VerificationSuccess.vue';
import CovidSurvey from '@js/components/my/CovidSurvey.vue';
import PasswordResetSuccess from '@js/components/my/PasswordResetSuccess.vue';
import ViewBooking from '@js/components/my/bookings/View.vue';
import BookingList from '@js/components/my/bookings/List.vue';
import SetupCreditCard from '@js/components/my/client/SetupCreditCard.vue';
import TermsAndConditionsAgreement from '@js/components/my/TermsAndConditionsAgreement.vue';
import InvitationsAccept from '@js/components/my/invitations/InvitationsAccept.vue';

const routes = [
	{
		path: '/',
		component: Dashboard,
		props: true,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/invitations/accept/:token',
		component: InvitationsAccept,
		props: true,
		meta: {
			requiresGuest: true
		}
	},
	{
		path: '/fees',
		component: FeesList,
		props: true,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/clean-homes-fees',
		component: CleanHomesFeesList,
		props: true,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/payments',
		component: PaymentsList,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/account',
		component: MyAccount,
		props: true,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/password/forgot',
		component: ForgotPassword,
		meta: {
			requiresGuest: true
		}
	},
	{
		path: '/password/reset/:token',
		component: PasswordReset,
		props: true,
		meta: {
			requiresGuest: true
		}
	},
	{
		path: '/registration-fee/:uuid',
		component: RegistrationFeeCheckout,
		props: true,
	},
	{
		path: '/job-offers/:uuid',
		component: JobOffer,
		props: true,
	},
	{
		path: '/payment-summaries',
		component: PaymentSummaries,
		props: true,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/verification-success',
		name: 'VerificationSuccess',
		component: VerificationSuccess
	},
	{
		path: '/reset-success',
		name: 'PasswordResetSuccess',
		component: PasswordResetSuccess
	},
	{
		path: '/cs/:token',
		name: 'CovidSurvey',
		props: true,
		component: CovidSurvey
	},
	{
		path: '/bookings',
		name: 'BookingList',
		component: BookingList,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/bookings/:uniqueId',
		name: 'ViewBooking',
		props: true,
		component: ViewBooking,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/setup-credit-card',
		name: 'SetupCreditCard',
		component: SetupCreditCard,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/terms-and-conditions-agreement',
		name: 'TermsAndConditionsAgreement',
		component: TermsAndConditionsAgreement,
		meta: {
			requiresAuth: true
		}
	},
	{
		// catch-all path '*' is now '/:pathMatch(.*)*'.
		path: '/:pathMatch(.*)*',
		name: 'not-found',
		component: PageNotFound
	},
];

const router = createRouter({
	// When dev'ing locally, myAbdom routes are setup as a /my url prefix instead of a subdomain.
	history: createWebHistory(import.meta.env.PROD ? '' : '/my/'),
	routes: routes,
	linkActiveClass: 'active'
});

router.beforeEach(async (to, from, next) => {

	if (to.matched.some(record => record.meta.requiresAuth)) {
		await store.dispatch('auth/fetchUser')
			.then(() => {
				if (to.name !== 'TermsAndConditionsAgreement') {
					if (!store.state.auth.user.hasAgreedToTerms) {
						return next('/terms-and-conditions-agreement')
					}
				}

				next()
			})
			.catch(() => {
				window.location = '/login'
			})
	} else {
		next()
	}
})

export default router
